import { DynamicLmnDsThemeProvider, pinkPantherTokens } from '@lmn/design-system';
import React, { FC, ReactNode } from 'react';
import { GlobalStyle } from './global-style';
import { Header } from '../organisms/header';
import { Footer } from '../organisms/footer';
import { FakeHeader } from '../atoms/fake-header';

interface Props {
  pathname?: string;
  children?: ReactNode;
}

export const Page: FC<Props> = ({ pathname, children }) => (
  <DynamicLmnDsThemeProvider themeTokens={pinkPantherTokens}>
    <GlobalStyle />
    <Header pathname={pathname} />
    <FakeHeader />
    {children}
    <Footer />
  </DynamicLmnDsThemeProvider>
);
